import { HStack } from '@shared/ui/Stack';

import cls from './Reviews.module.scss';

const MAX_RATE = 5;

export const Stars = ({ rate, className }: { rate: number; className?: string }) => (
  <HStack className={className}>
    {new Array(MAX_RATE).fill(0).map((_, index) => (
      <div
        key={index}
        className={index < rate ? cls.starActive : cls.star}
      />
    ))}
  </HStack>
);

type ReviewFormStarsProps = {
  selectedRate: number;
  hoveredRate: number;
  onChangeRate: (rate: number) => void;
  onChangeHoveredRate: (rate: number) => void;
};

export const ReviewFormStars = ({
  selectedRate,
  hoveredRate,
  onChangeRate,
  onChangeHoveredRate
}: ReviewFormStarsProps) => {
  const visibleRate = hoveredRate || selectedRate;

  return (
    <HStack className={cls.formStars}>
      {new Array(MAX_RATE).fill(0).map((_, index) => {
        const rate = index + 1;

        return (
          <button
            key={rate}
            className={cls.formStarButton}
            type={'button'}
            aria-label={`Поставить оценку ${rate}`}
            onClick={() => onChangeRate(rate)}
            onMouseEnter={() => onChangeHoveredRate(rate)}
            onMouseLeave={() => onChangeHoveredRate(0)}
          >
            <span className={rate <= visibleRate ? cls.starActive : cls.star} />
          </button>
        );
      })}
    </HStack>
  );
};
